import { render, staticRenderFns } from "./ProductBody.vue?vue&type=template&id=ac47422e&scoped=true&"
import script from "./ProductBody.vue?vue&type=script&lang=js&"
export * from "./ProductBody.vue?vue&type=script&lang=js&"
import style0 from "./ProductBody.vue?vue&type=style&index=0&id=ac47422e&scoped=true&lang=css&"
import style1 from "./ProductBody.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac47422e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
